import { _ } from '_core';

import { DraftParams } from './types';

export const getName = (params: DraftParams) => {
  const freq = params.aggregation == 'ANNUAL' ? 'Yearly' : params.aggregation;
  return `${_.startCase(freq)} Turnover`;
};
